<template>
  <app-set-price :closeButton="true" :cancel="closeFunction">
    <template v-slot:app-modal-header>
      <img src="@/Common/Icons/TheosLogo.svg" alt="TheosLogo" />
      <h3 class="app-modal-deposit-title">NFT PRICE</h3>
    </template>
    <template v-slot:app-modal-body>
      <p class="app-modal-body-text">You will get</p>
      <p class="app-modal-deposit-price">
        <span> {{ calculateTokenPrice }} {{ pool.tokenSymbol }}</span>
        <span class="price-color"> ≈ ${{ pool.nftBasePrice }} </span>
      </p>
      <div class="scrolling-content">
        <p class="app-modal-body-text text-color">
          <span class="app-modal-base-price">
            Base price {{ poolNftBasePrice }} {{ pool.tokenSymbol }}</span
          >
          <span class="price-color"> ≈ ${{ pool.nftBasePrice }} </span>
        </p>
        <div class="app-modal-details-control" @click="toggleDetails()">
          <span class="app-modal-details-control-text">See details</span>
          <img :src="arrowImage" class="arrow-image" alt="Arrow" name="arrow" />
        </div>
        <div class="app-modal-details" v-show="detailsShown">
          <span class="app-modal-details-main-text">For depositing</span>
          <div class="app-modal-details-rows">
            <div>
              <span class="app-modal-details-text">Base price</span>
              <span class="app-modal-details-values"
                >{{ poolNftBasePrice }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-details-price-dollars">
              ≈ ${{ pool.nftBasePrice }}
            </span>
            <div>
              <span class="app-modal-details-text">5% for social cause</span>
              <span class="app-modal-details-values"
                >- {{ depositingSocialCauseValue }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-details-price-dollars">
              ≈ ${{ depositingSocialCauseValueUsd }}
            </span>
            <div>
              <span class="app-modal-details-text"
                >{{ selectedNft.royaltyPercentage }} % for Royalty</span
              >
              <span class="app-modal-details-values"
                >- {{ depositingRoyaltyValue }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-details-price-dollars">
              ≈ ${{ depositingRoyaltyValueUsd }}
            </span>
          </div>
          <div class="splitter"></div>
          <div class="app-modal-total">
            <div>
              <span>Total after depositing</span>
              <span class="app-modal-total-values"
                >{{ depositingTotal }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-total-price-dollars">
              ≈ ${{ depositingTotalUsd }}
            </span>
          </div>
          <span class="app-modal-details-main-text">For selling</span>
          <div class="app-modal-details-rows">
            <div>
              <span class="app-modal-details-text">i price</span>
              <span class="app-modal-details-values">
                {{ sellingIPriceValue }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-details-price-dollars">
              ≈ ${{ sellingIPriceValueUsd }}
            </span>
            <!-- <div>
              <span class="app-modal-details-text">5% for social cause</span>
              <span class="app-modal-details-values">
                -{{ sellingIPriceSocialCauseValue }}
                {{ pool.tokenSymbol }}</span
              >
            </div> -->
            <!-- <span class="price-color app-modal-details-price-dollars">
              ≈ ${{ sellingIPriceSocialCauseValueUsd }}
            </span> -->
          </div>
          <div class="splitter"></div>
          <div class="app-modal-total">
            <div>
              <span>Total after selling</span>
              <span class="app-modal-total-values">
                {{ sellingTotal }} {{ pool.tokenSymbol }}</span
              >
            </div>
            <span class="price-color app-modal-total-price-dollars">
              ≈ ${{ sellingTotalUsd }}
            </span>
          </div>
        </div>
        <div class="nft-checkbox">
          <span class="app-modal-body-text app-modal-top-margin"
            >Set a higher price for my NFT
          </span>
          <img
            :src="switchStateImage"
            class="switch-image app-modal-top-margin"
            alt="Switch"
            name="tokenSwitch"
            @click="toggleHigherPrice()"
          />
        </div>
        <div v-if="higherPrice" class="higher-price">
          <p class="app-modal-deposit-bold-text">Increase base price by</p>
          <app-slider
            v-model="currentValue"
            :min="0"
            :max="pool.maximumIPrice"
            class="nft-modal-slider"
          ></app-slider>
          <div class="app-modal-you-will-receive">
            <div class="app-modal-warning-icon">
              <img
                class="app-modal-warning-icon-image"
                src="@/Common/Icons/Warning.png"
              />
            </div>
            <span class="app-modal-receive-text">
              You will receive this extra amount when someone buys your NFT
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:app-modal-footer>
      <app-button
        @click.prevent="confirmPrice()"
        buttonClass="app-modal-button-inverse"
        text="Confirm price"
      />
    </template>
  </app-set-price>
</template>

<script>
import { useStore } from "vuex";
import AppButton from "@/elements/AppButton.vue";
import AppSlider from "@/elements/AppSlider";
import { computed, ref, onMounted, onUnmounted } from "vue";
import AppSetPrice from "@/elements/AppSetPrice";
import usePool from "@/composables/usePool";
import useUtilities from "@/composables/useUtilities";

export default {
  name: "SetPriceModal",
  props: {
    nft: {
      type: Object,
      default: () => {},
    },
    pool: {
      type: Object,
      default: () => {},
    },
    closeFunction: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    AppSetPrice,
    AppButton,
    AppSlider,
  },
  setup(props) {
    const store = useStore();
    const higherPrice = ref(false);
    const detailsShown = ref(false);
    const toggleHigherPrice = () => {
      higherPrice.value = !higherPrice.value;
    };
    const toggleDetails = () => {
      detailsShown.value = !detailsShown.value;
    };
    const { setIValuePercentage, poolNftBasePrice, selectedNft } =
      usePool(store);
    const { toFixedIfNecessary } = useUtilities();
    const currentValue = ref(0);
    const confirmPrice = () => {
      setIValuePercentage(currentValue.value);
      props.closeFunction();
    };
    const switchStateImage = computed(() =>
      higherPrice.value === true
        ? require("@/Common/Icons/SwitchOn.png")
        : require("@/Common/Icons/SwitchOff.png")
    );
    const arrowImage = computed(() =>
      detailsShown.value === true
        ? require("@/Common/Icons/up_arrow_icon.svg")
        : require("@/Common/Icons/down_arrow_icon.svg")
    );
    const calculateTokenPrice = computed(() => {
      return toFixedIfNecessary(
        Number(poolNftBasePrice.value) +
          (currentValue.value / 100) * poolNftBasePrice.value,
        4
      );
    });
    const depositingSocialCauseValue = computed(() =>
      toFixedIfNecessary((poolNftBasePrice.value / 100) * 5, 4)
    );
    const depositingSocialCauseValueUsd = computed(() =>
      toFixedIfNecessary((props.pool.nftBasePrice / 100) * 5, 2)
    );
    const depositingRoyaltyValue = computed(() =>
      toFixedIfNecessary(
        ((poolNftBasePrice.value - depositingSocialCauseValue.value) / 100) *
          selectedNft.value.royaltyPercentage,
        4
      )
    );
    const depositingRoyaltyValueUsd = computed(() =>
      toFixedIfNecessary(
        ((props.pool.nftBasePrice - depositingSocialCauseValueUsd.value) /
          100) *
          selectedNft.value.royaltyPercentage,
        2
      )
    );
    const depositingTotal = computed(() =>
      toFixedIfNecessary(
        poolNftBasePrice.value -
          depositingRoyaltyValue.value -
          depositingSocialCauseValue.value,
        4
      )
    );
    const depositingTotalUsd = computed(() =>
      toFixedIfNecessary(
        props.pool.nftBasePrice -
          depositingSocialCauseValueUsd.value -
          depositingRoyaltyValueUsd.value,
        2
      )
    );
    const sellingIPriceValue = computed(() =>
      toFixedIfNecessary((currentValue.value / 100) * poolNftBasePrice.value, 4)
    );
    const sellingIPriceValueUsd = computed(() =>
      toFixedIfNecessary(
        (currentValue.value / 100) * props.pool.nftBasePrice,
        2
      )
    );
    const sellingIPriceSocialCauseValue = computed(() =>
      toFixedIfNecessary(
        (currentValue.value / 100) * poolNftBasePrice.value * (5 / 100),
        4
      )
    );
    const sellingIPriceSocialCauseValueUsd = computed(() =>
      toFixedIfNecessary(
        (currentValue.value / 100) * props.pool.nftBasePrice * (5 / 100),
        2
      )
    );
    const sellingTotal = computed(() =>
      toFixedIfNecessary(sellingIPriceValue.value, 4)
    );
    const sellingTotalUsd = computed(() =>
      toFixedIfNecessary(sellingIPriceValueUsd.value, 2)
    );
    onMounted(() => document.body.classList.add("stop-scroll"));
    onUnmounted(() => document.body.classList.remove("stop-scroll"));
    return {
      arrowImage,
      higherPrice,
      selectedNft,
      sellingTotal,
      detailsShown,
      currentValue,
      confirmPrice,
      toggleDetails,
      depositingTotal,
      sellingTotalUsd,
      switchStateImage,
      poolNftBasePrice,
      toggleHigherPrice,
      sellingIPriceValue,
      depositingTotalUsd,
      calculateTokenPrice,
      sellingIPriceValueUsd,
      depositingRoyaltyValue,
      depositingRoyaltyValueUsd,
      depositingSocialCauseValue,
      depositingSocialCauseValueUsd,
      sellingIPriceSocialCauseValue,
      sellingIPriceSocialCauseValueUsd,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/depositReview.scss"></style>
